'use client';

import { FC } from 'react';

import { Chat } from '../Chat/Chat';
import { ChatEventsListener } from '../Chat/ChatEventsListener';
import { Recaptcha } from '../Recaptcha/Recaptcha';

/**
 * Load third party libraries such as LiveChat or Recaptcha
 */
export const ThirdPartyLibraries: FC = () => (
  <>
    <Chat />
    <ChatEventsListener />
    <Recaptcha />
  </>
);
